// @flow
export * from './comparable';
export * from './stateModel';
export * from './svg';
export * from './date';

export function isUndef(value: any): boolean {
  return value === undefined || value === null;
}

export function isDef(value: any): boolean {
  return !isUndef(value);
}

export function isArray(item: any): boolean {
  return Array.isArray(item);
}

export function isObject(item: any): boolean {
  return Boolean(item && typeof item === 'object' && !Array.isArray(item));
}

export function isFunction(item: any): boolean {
  return typeof item === 'function';
}

export function isString(item: any): boolean {
  return typeof item === 'string';
}

export function copy(item: any) {
  return JSON.parse(JSON.stringify(item));
}

export function serialize(obj: Object): string {
  if (!isObject(obj)) { return ''; }

  return Object.keys(obj)
    .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`)
    .join('&');
}

export function isEmpty(item: any): boolean {
  if (isArray(item) || isString(item)) {
    return !item.length;
  }
  if (isObject(item)) {
    return !Object.keys(item).length;
  }
  return false;
}

export function formatArrayForLabel(arr: Array<string>): string {
  if (!arr || !arr.length) return '';
  if (arr.length === 1) return arr[0];

  const indexLength = arr.length - 1;
  const lastString = arr[indexLength];
  const joinedArray = arr.slice(0, indexLength).join(', ');

  return `${joinedArray} e ${lastString}`;
}

export function arrayToQueryString(array_in, identifier) {
  const out = new Array();
  for (const key in array_in) {
    out.push(`${identifier}[]=${encodeURIComponent(array_in[key])}`);
  }
  return out.join('&');
}
